import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-message-box',
	templateUrl: './message-box.component.html',
	styleUrls: ['./message-box.component.scss'],
})
export class MessageBoxComponent {
	@Input() type: 'note' | 'warning' = 'note';
	@Input() message: string;
}
